import React from 'react';
import Fire from '../config/Fire';
import moment from "moment"
import axios from 'axios';
import Aux from '../utils/AuxFunctions';
const DataContext = React.createContext();
const LIMIT = 5;

const AllAchievements = [
    //beginner

    { id: 0, text: "Every 10 likes", reward: 1, toComplete: 10, currentlyHave: 0, state: "", type: "likesToEarn" },

    { id: 1, text: "Create a post", reward: 1, toComplete: 1, currentlyHave: 0, state: "", type: "post" },
    { id: 2, text: "Get a friend to use your referral link", reward: 10, toComplete: 1, currentlyHave: 0, state: "", type: "referral" },
    
    { id: 3, text: "Get a total 3 comments on your posts", reward: 5, toComplete: 20, currentlyHave: 0, state: "", type: "comment" },
    { id: 4, text: "Spend a total of 30$", reward: 10, toComplete: 30, currentlyHave: 0, state: "", type: "spend_total" },

    //intermitate
    { id: 5, text: "Create 10 posts", reward: 10, toComplete: 10, currentlyHave: 0, state: "", type: "post" },
    { id: 6, text: "Get 5 friends to use your referral link", reward: 25, toComplete: 5, currentlyHave: 0, state: "", type: "referral" },
    { id: 7, text: "Get 50 likes on your posts", reward: 25, toComplete: 50, currentlyHave: 0, state: "", type: "likes" },
    { id: 8, text: "Get a total of 20$ spent in comments on your posts", reward: 10, toComplete: 20, currentlyHave: 0, state: "", type: "comment_total" },
    { id: 9, text: "Spend a total of 100$", reward: 20, toComplete: 100, currentlyHave: 0, state: "", type: "spend_total" },
]

const allDailyRewards = [
    { day: 1, reward: 1, state: false },
    { day: 2, reward: 1, state: false },
    { day: 3, reward: 1, state: false },
    { day: 4, reward: 1, state: false },
    { day: 5, reward: 1, state: false },
    { day: 6, reward: 5, state: false },
]



export class DataProvider extends React.Component {
    state = {
        user: null,
        createUsername: false,
        coins: 0,
        loadingState:"loading",

        notificationsData: [],
        finished:false,
        loading:false,
        newNotifications: false,
        lastVisible: null,
        hashtag: "",

        pendingCode: "",
        pendingCodeReward:0,
        pendingReferralUser: "",

        statistics: {},
        hasNewAchievement: false,
        achievementsList: AllAchievements,
        currentTimestamp: 0,

        tags: [],
        loadingTags:false,
        dailyRewards: allDailyRewards,
        hasNewDailyReward: false,

        newMessage:false,
        messagesData: [],
        loadingMessages: false,
        currentViewingMessage: "",
    }
    
    isStart = false;
    userListener = null;
    notificationsListener = null;
    achievementsListener = null;


    componentDidMount = () =>{
        this.isStart = true;
        try{
            Fire.shared.firebase.auth().onAuthStateChanged(async user => {
                if(user){
                    this.init(user);
                    this.checkIfCodeOrReferral(user);
                    //this.checkIfNewDailyReward(user)
                    this.setState({loadingState:"connected"})
                }else{
                    this.setState({user: null})
                    this.setState({loadingState:"disconnected"})
                }
            })  
            this.getTimeFromServer();
            this.getTopTags();
        }catch(error){
            Aux.handleError(error)
            this.setState({loadingState:"disconnected"})
        }
    }

    componentWillUnmount() {
        this.userListener()
        this.messagesListener()
        this.notificationsListener()
        this.achievementsListener()
    }

    init = (user) => {
        try{
            this.createUserListener();
            if(user){
                this.getNewNotifications(true);
                this.createMessagesListener();
                this.getAchievementsListener(user);
                //this.checkIfNewDailyReward(user)
            }
        }catch(error){
            Aux.handleError(error)
        }
    }

    updateUserDummy = (user) =>{
        try {
            this.userListener()
            this.messagesListener()
            this.notificationsListener()
            this.achievementsListener()
            this.setState({user:null, messagesData: [], newMessage: false, loadingMessages:false})

           /*  this.createUserListener();
            this.getNewNotifications(true);
            this.createMessagesListener(); */
             this.init(user)
        } catch (error) {
            Aux.handleError(error)
        }
    }
    
    checkIfCodeOrReferral = (user) =>{
        if(this.state.pendingReferralUser){
            this.submitInitialLink(user);
        }
        if(this.state.pendingCode){
            this.AddPromoCode();
        }
    }

    onSignOut = () => {
        this.userListener()
        this.messagesListener()
        this.notificationsListener()
        this.achievementsListener()
        Fire.shared.signOutUser()
        this.setState({user:null, messagesData: [], newMessage: false, loadingMessages:false})
    }

    AddPromoCode = async() =>{
        if(!this.state.pendingCode)
            return
        try {
            await Fire.shared.addPromoCode(this.state.pendingCode, this.state.pendingCodeReward)
            this.setState({pendingCode:"", pendingCodeReward:0})
        } catch (error) {
            Aux.handleError(error)
        }
    }

    submitInitialLink = async (user) => {
        if (user.referralUser) {
            return;
        }
        if (!this.state.pendingReferralUser) {
            return;
        }
        if (this.state.pendingReferralUser === Fire.shared.uid) {
            return;
        }
        try {
            const status = await Fire.shared.InitialReferralLinkUid(this.state.pendingReferralUser)
            if (status === 2) {
            } else if (status !== "") {
                this.setState({ pendingReferralUser: "" })
            }
        } catch (error) {
            Aux.handleError(error)
        }
    }

    getTopTags = async () => {
        try{
            this.setState({loadingTags:true})
            await Fire.shared
                .GetPostsData("hashtags", null, 20)
                .then(snapshot => {
                    if (snapshot) {

                        let data = snapshot.docs.map(document => {
                            const doc = document.data();
                            doc.id = document.id;
                            return doc;
                        });

                        var n = data.length
                        var aux = 0
                        if(n < 20){
                            for (let index = n; index < 20; index++) {
                                data[index] = Aux.temporaryTags[aux]
                                aux ++;
                            }
                        }
                        this.setState({tags: data, loadingTags:false})
                    } 
                });
                this.setState({loadingTags:false})
        }catch(error){
            Aux.handleError(error)
            this.setState({loadingTags:false})
        }
    }

    getDaysSince = () => {
        if(!this.state.currentTimestamp)
            return null
        try {
            var lastDate = 1627394625 
            var myDay = (this.state.currentTimestamp - lastDate ) / 86400
            var daysSince = Math.round(myDay)
            //console.log(daysSince)
            return daysSince
        } catch (error) {
            Aux.handleError(error)
            return null
        }
            
    }

    getTimeFromServer = async () => {
        try {
            /* let newDate = this.getTime(Date.now())
            this.setState({currentTimestamp: newDate}) */
            const result = await axios.post(process.env.REACT_APP_API_URL_TIME)
            if(result.status === 200){
                let newDate = this.getTime(result.data.date)
                this.setState({currentTimestamp: newDate})
                //var currentDate = 1627394625
                /* var lastDate = 1627394625 
                var myDay = (newDate - lastDate ) / 86400
                var daysSince = Math.round(myDay)
                console.log(daysSince) */
            }
        } catch (error) {
            Aux.handleError(error)
        }
    }

    getTime = (date) => {
        try {
            if (date) {
                var time = moment(date).unix()
                return time || "error";
            } else {
                return "error"
            }
        } catch (error) {
            Aux.handleError(error)
        }
    }

    createUserListener = async() => {
        try{
            const initialQuery = Fire.shared.firestore.collection('users').doc(Fire.shared.uid)
            this.userListener = initialQuery.onSnapshot((doc) => {
                if(doc.exists){
                    this.setState({user:doc.data(), coins: doc.data().coins})
                    this.checkIfNewDailyReward(doc.data())
                }else if(!this.isStart){
                    this.onSignOut();
                }
            })
        }catch(error){
            Aux.handleError(error)
        }
    }

    getAchievementsListener = async (user) => {
        try {
            const initialQuery = Fire.shared.firestore.collection('users').doc(Fire.shared.uid).collection("statistics").doc("statistics")

            this.achievementsListener = initialQuery.onSnapshot((doc) => {
                if (doc.exists) {
                    this.setState({ statistics: doc.data() })
                    this.checkifNewAchievements(doc.data(),  user || this.state.user )
                } else {
                    this.checkifNewAchievements({},  user || this.state.user )
                }
            })
        } catch (error) {
            Aux.handleError(error)
        }
    }

    checkifNewAchievements = (statistics, user) => {
        let achievList = this.state.achievementsList;
        try {
            achievList.forEach(achivement => {
                achivement.state = "";
                achivement.currentlyHave = 0
                switch (achivement.type) {
                    case "likesToEarn":
                        achivement.currentlyHave = statistics.likesToEarn || 0
                        achivement.icon = "heart"
                        break;
                    case "likes":
                        achivement.currentlyHave = statistics.likesCount || 0
                        achivement.icon = "heart"
                    break;
                    case "comment":
                        achivement.currentlyHave = statistics.commentCount || 0
                        achivement.icon = "comment"
                        break;
                    case "referral":
                        achivement.currentlyHave = statistics.referralCount || 0
                        achivement.icon = "account-multiple"
                        break;
                    case "send_message":
                        achivement.currentlyHave = statistics.messagesSent || 0
                        achivement.icon = "message"
                        break;
                    case "post":
                        achivement.currentlyHave = user.postsCount || 0
                        achivement.icon = "note"
                        break;
                    case "comment_total":
                        achivement.currentlyHave = statistics.commentCoinsTotal || 0
                        achivement.icon = "comment"
                        break;
                    case "spend_total":
                        achivement.currentlyHave = user.coinsSpent || 0
                        achivement.icon = "cash-usd"
                        break;
                    default:
                        achivement.currentlyHave = 0
                        achivement.icon = "heart"
                        break;
                }

                if (statistics[achivement.id]) {
                    achivement.state = "rewarded"
                    achivement.icon = "check-bold"
                } else if (achivement.currentlyHave >= achivement.toComplete && achivement.state !== "rewarded") {
                    achivement.state = "complete"
                    this.setState({ hasNewAchievement: true })
                    //achivement.icon = "check-bold"
                } else {
                    achivement.state = ""
                }
                return achivement;

            });
            //this.setState({achievementsList: achievList})

        } catch (error) {
            Aux.handleError(error)
        }
    }

    getNewNotifications = async (isStart) => {
        //let start = null;
        try {
            if ((!isStart && this.state.finished) || this.state.loading)
                return;

            this.setState({ loading: true });
            if (isStart) {
                this.setState({
                    notificationsData: [],
                    lastVisible: null,
                    finished: false,
                })
            }
            let ref = Fire.shared.firestore.collection('users').doc(Fire.shared.uid)
                .collection('activity')

            let firstQuery = ref.orderBy('timestamp', 'desc')
                .limit(LIMIT)

            if (this.state.lastVisible && !isStart) {
                firstQuery = firstQuery.startAfter(this.state.lastVisible);
            }

            await firstQuery.get()
                .then((query) => {

                    if (query.length < LIMIT || query.empty) {
                        this.setState({ finished: true })
                    }

                    let data = query.docs.map(document => {
                        const doc = document.data();
                        doc.id = document.id;
                        return doc;
                    });
                    this.setState({
                        notificationsData: [...this.state.notificationsData, ...data],
                        lastVisible: query.docs[query.docs.length - 1],
                        loading: false,
                    })
                    const start = query.docs[0]
                    if (isStart) {
                        if (this.notificationsListener) {
                            this.notificationsListener();
                        }
                        if (start) {
                            if(this.state.user){
                                if (this.state.user.lastNotification !== start.id) {
                                    this.setState({ newNotifications: true })
                                }
                            }
                        }
                        this.createNotificationsListener(ref, start)
                    }

                })
        } catch (error) {
            this.setState({ loading: false });
            Aux.handleError(error)
        }
    }

    checkIfNewDailyReward = (user) => {
        if(!user)
            return
        try {
            if(user.lastDayReward === 0 || !user.lastDayReward){
                this.setState({hasNewDailyReward: true})
            }
            let previousDate = this.getTime(user.lastTimestamp?.toDate()) + 24*60*60 //(24*60*60)
                if (this.state.currentTimestamp > previousDate) {
                    this.setState({hasNewDailyReward: true})
                }
        } catch (error) {
            Aux.handleError(error)
        }
    }

    createNotificationsListener = (ref, start) => {
        try{
        var query = ref.orderBy('timestamp')
        if (start && start.data().timestamp) {
            query = query.startAt(start)
        }
        this.notificationsListener = query.onSnapshot({ includeMetadataChanges: false }, (snap) => {        // append new messages to message array
            snap.docChanges().forEach((doc) => {
                let newActivity = null;
                if (doc.doc.data().timestamp) {
                    newActivity = doc.doc.data();
                    newActivity.id = doc.doc.id;

                    let activities = this.state.notificationsData;
                    activities = activities.filter(x => x.id !== newActivity.id)
                    activities.unshift(newActivity);
                    this.setState({ notificationsData: activities })
                    if (doc.type === "modified" || doc.type === "added") {
                        if(doc.doc.id !== this.state.user.lastNotification){
                            this.setState({ newNotifications: true })
                        }
                    }
                }
            })

        })
    }catch(error){
        Aux.handleError(error)
    }
    }

    messagesListener = null;
    createMessagesListener = () => {
        try{
            let initialQuery = Fire.shared.firestore.collection('chats')
                    .where("users", "array-contains", Fire.shared.uid).orderBy("lastMessage.timestamp", "desc")
            this.messagesListener = initialQuery.onSnapshot({ includeMetadataChanges: false }, (snap) => {
                snap.docChanges().forEach((doc) => {
                    if(doc.type === "added"){
                        if (doc.doc.data().lastMessage?.timestamp) {
                            let newMessage = doc.doc.data();
                            newMessage.id = doc.doc.id;
                            let myMessages = this.state.messagesData;
                            myMessages = myMessages.filter(x => x.id !== newMessage.id)
                            this.setState({ messagesData: [...myMessages, newMessage]})
                            //this.setState({ messagesData: [...this.state.messagesData, newMessage]})
                        }
                    }
                    else if(doc.type === "modified"){
                        if (doc.doc.data().lastMessage?.timestamp) {
                            let newMessage = doc.doc.data();
                            newMessage.id = doc.doc.id;
                            let myMessages = this.state.messagesData;
                            myMessages = myMessages.filter(x => x.id !== newMessage.id)
                            myMessages.unshift(newMessage);
                            if(this.state.currentViewingMessage === doc.doc.id){
                                this.setState({ messagesData: myMessages }) 
                            }else{
                                this.setState({ messagesData: myMessages, newMessage: true }) 
                            }
                            
                        }
                    }
                })

            })
        }catch(error){
            Aux.handleError(error)
        }
    }

   /*  requestsListener = null;
    createRequestsListener = (ref, start) => {
        let initialQuery = Fire.shared.firestore.collection('users')
                .where("users", "array-contains", Fire.shared.uid)
        this.messagesListener = initialQuery.onSnapshot({ includeMetadataChanges: false }, (snap) => {
            snap.docChanges().forEach((doc) => {
                if (doc.type === "modified" && !this.state.newMessage) {
                    console.log("User got a new message")
                    this.setState({ newMessage: true })
                }
                
            })

        })
    } */

    setNewNofitications = (newNotification) => {
        let user = this.state.user;
        user.lastNotification = newNotification;
        this.setState({ user: user, newNotifications: false })
    }

    setNewHashtag = (hashtag) =>{
        this.setState({hashtag:hashtag})
    }

    setNewMessage = (newMessage) => {
        this.setState({newMessage: newMessage})
    }

    setNewCurrentMessage = (id) => {
        this.setState({currentViewingMessage: id})
    }

    setNewAchievement = (newAchievement) => {
        this.setState({hasNewAchievement: newAchievement})
    }

    setNewDailyReward = (newReward) => {
        this.setState({hasNewDailyReward: newReward})
    }

    setNewPendingCode= (code, reward) => {
        this.setState({pendingCode:code, pendingCodeReward:reward})
    }

    setNewPendingReferralUser = (user) => {
        this.setState({pendingReferralUser:user})
    }
    getValues = () => {
        return {
            user: this.state.user,
            isLoggedIn: this.state.user,
            loadingState: this.state.loadingState,


            init: this.init,
            signOut: this.onSignOut,
            coins: this.state.coins,
            currentHashtag: this.state.hashtag,
            setNewHashtag: this.setNewHashtag,

            pendingCode: this.state.pendingCode,
            pendingCodeReward: this.state.pendingCodeReward,
            setPendingCode: this.setNewPendingCode,
            pendingReferralUser: this.state.pendingReferralUser,
            setPendingReferralUser: this.setNewPendingReferralUser,

            statistics: this.state.statistics,

            achievementsList: this.state.achievementsList,
            hasNewAchievement: this.state.hasNewAchievement,
            setNewAchievement: this.setNewAchievement,

            currentTimestamp: this.state.currentTimestamp,
            getServerTimestamp: this.getTimeFromServer,

            newNotifications: this.state.newNotifications,
            notifications: this.state.notificationsData,
            notificationsFinished: this.state.finished,
            notificationsLoading: this.state.loading,
            setNewNofitications: this.setNewNofitications,
            getNotifications: this.getNewNotifications,

            newMessage: this.state.newMessage,
            messagesData: this.state.messagesData,
            loadingMessages: this.state.loadingMessages,
            setNewMessage: this.setNewMessage,
            setNewCurrentMessage: this.setNewCurrentMessage,

            hasNewDailyReward: this.state.hasNewDailyReward,
            setNewDailyReward: this.setNewDailyReward,

            getDaysSince: this.getDaysSince,

            tags: this.state.tags,
            loadingTags:this.state.loadingTags,
            getTags: this.getTopTags,

            updateUserDummy: this.updateUserDummy,

        }
    }


    render() {
        return (
            <DataContext.Provider value={this.getValues()}>
                {this.props.children}
            </DataContext.Provider>
        );
    }

    
}

export function withMyDataContext(Component) {
    class ComponentWithContext extends React.Component {
        render() {
            return (
                <DataContext.Consumer>
                    {(value) => <Component {...this.props} myDataProvider={value} />}
                </DataContext.Consumer>
            );
        };
    }

    return ComponentWithContext;
}